export default{
    init(){
        this.tabSwitcher();
    },
    tabSwitcher(){
        $('.tab-button').click(function() {
            const tab_name = $(this).data('tab');
            const container = $(this).parents('.expertise-block-content');
            container.find('.tab-button').removeClass('active');
            $(this).addClass('active');
            container.find('.tab-preview.d-flex').toggleClass(['d-flex', 'd-none']);
            container.find(`.tab-preview.${tab_name}`).toggleClass(['d-flex', 'd-none']);
        });
    }
}
